import { ProcedimentosState } from "../../types/state.types";
import { StoreAction } from "../reduxTypes";
import * as actions from "./actions";

const emptyProcedimentoForm = {
  ID: 0,
  Data: "",
  ID_ProcedimentoContrato: -1,
  Paciente: "",
  Prontuario: "",
  Quantidade: "0",
  Valor: "0,00",
};
const initialState: ProcedimentosState = {
  requisitado: false,
  filtros: {
    competencia: "",
    contrato: "0",
  },
  form: emptyProcedimentoForm,
  listaContratos: [],
  listaProcedimentos: [],
  loading: false,
};

const reducer = (
  state: ProcedimentosState = initialState,
  action: StoreAction
): ProcedimentosState => {
  switch (action.type) {
    case actions.INICIALIZA_ESTADO:
      return {
        ...state,
        requisitado: true,
      };

    case actions.SET_CONTRATOS:
      return {
        ...state,
        listaContratos: [{ ID: 0, Nome: "Todos" }, ...action.payload],
      };

    case actions.SET_LISTA_PROCEDIMENTOS:
      return {
        ...state,
        listaProcedimentos: [
          { ID: -1, Procedimento: { Nome: "Selecionar" }, Valor: 0.0 },
          ...action.payload,
        ],
      };

    case actions.SET_DADOS_PROCEDIMENTOS:
      return {
        ...state,
        dadosProcedimentos: action.payload,
      };

    case actions.SET_FILTROS:
      return {
        ...state,
        filtros: action.payload,
      };

    case actions.SET_FORM:
      return {
        ...state,
        form: action.payload,
      };

    case actions.LIMPAR_FILTROS:
      return {
        ...state,
        filtros: initialState.filtros,
      };
    case actions.LIMPAR_FORM:
      return {
        ...state,
        form: action.payload
          ? initialState.form
          : {
              ...state.form,
              ID_ProcedimentoContrato: -1,
              Data: "",
              Quantidade: "0",
              Valor: "0,00",
            },
      };

    case actions.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
        // dadosIR: initialState.dadosIR,
      };

    case "SESSION__LOGOUT":
      return initialState;

    default:
      return state;
  }
};

export default reducer;
